import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fotile.png'


const _withScopeId = n => (_pushScopeId("data-v-29699547"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-view" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "login-page" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "账号登录", -1))
const _hoisted_6 = { class: "login-main" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "record-number",
    href: "https://beian.miit.gov.cn"
  }, "铭垚科技报表系统 沪ICP备15057767号-9")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_view = _resolveComponent("login-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      style: {"position":"absolute","top":"0","bottom":"0","left":"0","right":"0","width":"100vw","height":"100vh","z-index":"1"},
      src: require('@/assets/images/home/miyo-background.png')
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_login_view, { onLoginEvent: _ctx.loginSuccess }, null, 8, ["onLoginEvent"])
      ])
    ]),
    _hoisted_7
  ]))
}